import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

interface IRemoveModelModalProps extends RouteComponentProps {
  setting: { label: string; id: string }
  id: string
  removeVehicleModel: (id: string) => Promise<any>
}

export default class RemoveModelModal extends React.Component<IRemoveModelModalProps> {
  public render() {
    return (
      <SettingRemoveModal
        setting={this.props.setting ? this.props.setting : { label: '', id: '' }}
        settingType='Make'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.removeVehicleModel(this.props.id).then(() => {
      setTimeout(() => {
        this.onClose()
      }, 1000)
    })
  }
  private onClose = () => {
    this.props.history.push('/global-settings/model')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveModelModal.tsx